import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookCheckboxWrapper } from 'src/components/CookbookCheckboxWrapper/CookbookCheckboxWrapper';

export interface LocationInternalIDControlProps {
  name: string;
  id: string;
}

export function LocationInternalIDControl({
  name,
  id,
}: LocationInternalIDControlProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookCheckboxWrapper
      control={control}
      id={id}
      name={name}
      label="Enable location internal ID"
    />
  );
}
